import React from 'react'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { MeetingItem } from '../../types'
import getMugshotSrc from '../../../../utils/getMugshotSrc'
import { formatJobInfo, formatName } from '../../../../utils/profile'
import CapacityAndDateTime from '../CapacityAndDateTime'
import JoinMeetingButton from '../JoinMeetingButton'
import { _ } from '../../../../utils/localization'
import openChatModal from '../../../chat/openChatModal'
import useSlug from '../../../../hooks/useSlug'
import { currentUserSelector } from '../../../auth/authSlice'
import openBusinessCard from '../../../profile/openBusinessCard'
import { User } from '../../../auth/types'
import colors from '../../../../constants/colors'
import showMeetingInfoModal from '../../showMeetingInfoModal'
import useFetchAttendees from '../../../attendees/useFetchAttendees'
import Bookmark from '../../../goodiebag/Bookmark'
import { GoodiebagType } from '../../../goodiebag/types'

const S = {
    Body: styled(Card.Body)`
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      //height: 376px;
      height: 396px;
    `,
    BookMarkPosition: styled.div`
        position: absolute;
    `,
    InfoWrapper: styled.div`
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
    `,
    Image: styled.img`
      width: 83px;
      height: 83px; 
      border-radius: 120px;
      margin: 5px;
    `,
    Name: styled.p`
      font-size: 16px;
      height: 24px;
      margin: 0;
    `,
    JobInfo: styled.p`
      color: ${colors.regentGray};
      font-size: 12px;
      margin-top: 0;
      margin-bottom: 3px;
      height: 18px;
    `,
    MeetingTitle: styled.div`
      font-size: 16px;
      font-weight: 500;
      height: 68px;
      display: flex;
      align-items: center;
    `,
    CapacityAndDateTime: styled.div`
      height: 48px;
      display: flex;
      width: 100%;
    `,
    Hr: styled.hr`
      width: 100%;
      margin-top: 5px;
      margin-bottom: 5px;
    `,
    Buttons: styled.div`
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 12px 0;
    `,
    WaitForHost: styled.div`
        color: red;
    `,
    Bookmark: styled.div`
        position: absolute;
        top: 20px;
        left: 20px;
    `,
}

const MeetingCard = ({ meeting }: { meeting: MeetingItem }) => {
    const dispatch = useDispatch()
    const eventSlug = useSlug('eventSlug')
    const currentUser = useSelector(currentUserSelector())
    const isHost = currentUser.id === meeting.host_id
    const [fetchedHost] = useFetchAttendees([meeting.host_id])
    const host = isHost ? currentUser : fetchedHost

    return (
        <Card>
            {host && (
                <S.Body>
                    <S.Bookmark>
                        <Bookmark item={{id: meeting.id, type: GoodiebagType.MeetingExpert}} />
                    </S.Bookmark>
                    {!meeting.is_host_in_call && !isHost && (
                        <S.WaitForHost>{_('meetingspace.waiting_for_host')}</S.WaitForHost>
                    )}
                    <S.InfoWrapper onClick={() => dispatch(openBusinessCard(host as User))}>
                        <S.Image alt="" src={getMugshotSrc(host)} />
                        <S.Name className="text-cut-line-1">
                            {formatName(host)}
                        </S.Name>
                        <S.JobInfo className="text-cut-line-1">
                            {formatJobInfo(host)}
                        </S.JobInfo>
                    </S.InfoWrapper>
                    <S.Hr />
                    <S.InfoWrapper onClick={() => dispatch(showMeetingInfoModal(meeting))}>
                        <S.MeetingTitle>
                            <div className="text-cut-line-1">{meeting.title}</div>
                        </S.MeetingTitle>
                        <S.Hr />
                        <S.CapacityAndDateTime>
                            <CapacityAndDateTime meeting={meeting} showDate />
                        </S.CapacityAndDateTime>
                    </S.InfoWrapper>
                    <S.Hr />
                    <S.Buttons>
                        {meeting.enable_host_chat && !isHost
                            ? (
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => dispatch(openChatModal(eventSlug, meeting.host_id))}
                                >
                                    {_('meetingspace.send_message_button')}
                                </Button>
                            ) : (
                                <div />
                            )}
                        <JoinMeetingButton meeting={meeting} location="card" />
                    </S.Buttons>
                </S.Body>
            )}
        </Card>
    )
}
export default MeetingCard
